import { createClient } from '@supabase/supabase-js'

// ── FIX #1: Key moved to env var — never hardcode in source ──────────────────
// Set REACT_APP_SUPABASE_ANON_KEY in Vercel → Settings → Environment Variables
const SUPABASE_URL      = 'https://jtbcsoticxzkohykwsgs.supabase.co'
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!SUPABASE_ANON_KEY) {
  console.error('⚠ REACT_APP_SUPABASE_ANON_KEY is not set. Check your environment variables.')
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    detectSessionInUrl: true,
    persistSession:     true,
    // Was `false` — with it off, the SDK never silently renews the ~1hr
    // access token, so anyone still active in the app got logged out mid-
    // session. Re-enabled so Supabase's own refresh-token timer keeps the
    // session alive; keepAlive() below is a separate, additional nudge for
    // when a background/inactive tab comes back into focus.
    autoRefreshToken:   true,
    storageKey:         'uniedd-lms-auth',
    flowType:           'implicit',
  },
})

export const AUTO_REFRESH_ENABLED = true

// ── FIX #2: keepAlive only runs when a user is signed in ─────────────────────
// Previously it fired unconditionally on every page load (even the login page)
function keepAlive() {
  supabase.auth.getSession().then(({ data: { session } }) => {
    if (session) {
      supabase.from('profiles').select('id').limit(1).then(() => {})
    }
  })
}

if (AUTO_REFRESH_ENABLED) {
  // Ping immediately on load
  keepAlive()

  // Then every 4 minutes while the tab is open
  setInterval(keepAlive, 4 * 60 * 1000)

  // Also ping when user comes back to the tab
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') keepAlive()
  })
}
